import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Legal.css';

/**
 * Affiché à la place des formulaires de saisie quand la sportive a retiré son
 * consentement au traitement de ses données de santé : le serveur refuserait
 * l'enregistrement, mieux vaut le dire avant qu'elle ait tout rempli.
 */
const HealthConsentWithdrawn = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-page__header">
        <button className="legal-page__back-btn" onClick={() => navigate(-1)} aria-label="Retour">
          <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
        <h1 className="legal-page__title">Saisie désactivée</h1>
      </div>

      <div className="legal-page__card">
        <p className="legal-page__section-text">
          Tu as retiré ton consentement au traitement de tes données de santé : CycleGala
          n'enregistre plus de relevé de cycle, de mental ni de sport.
        </p>
        <p className="legal-page__section-text">
          Tu peux le donner à nouveau à tout moment depuis ton profil, rubrique « Mes données ».
        </p>
        <button className="legal-page__form-submit" onClick={() => navigate('/profil')}>
          Aller à mon profil
        </button>
      </div>
    </div>
  );
};

export default HealthConsentWithdrawn;
